import React, { useContext, useState } from "react";
import { Button, Card, Stack } from "react-bootstrap";
import AppContext from "../../context/AppContext";
import RentNow from "../modals/RentNow";
import { Link } from "react-router-dom";

const Post = ({ item }) => {
  const {
    storeSeletedVehicle,
    storeIsPickupLocation,
    storeIsDropOffLocation,
    baseUrl,
  } = useContext(AppContext);

  const [showModal, setShowModal] = useState(false);

  return (
    <>
      <Card className="post-card border-0">
        <Card.Img
          src={`${baseUrl}/storage/${item.image}`}
          className="post-card-img"
          alt="Car Image"
        />
        {/* <Container className="bottom-fade"></Container> */}
        <Card.Body className="post-card-body">
          <Card.Title className="poppins-semiBold res-headind txt-green">
            {item.title}
          </Card.Title>
          <Stack gap={3} direction="horizontal">
            <p className="poppins-bold res-tiny-text txt-black">
              {item.description}
            </p>
          </Stack>
          <Link
            to={{pathname:`/post/${item.slug}`}}
            className="btn poppins-bold orange-outline-btn px-2 py-1"
            onClick={() => {
              storeSeletedVehicle(item.id);
              storeIsDropOffLocation(false);
              storeIsPickupLocation(false);
              setShowModal(true);
            }}
          >
            Read More
          </Link>
        </Card.Body>
      </Card>
      <RentNow isVisible={showModal} hideModel={() => setShowModal(false)} />
    </>
  );
};

export default Post;
